import templateUrl from "./tags.html";
import find from "lodash/find";

export const tagComponent = {
  bindings: {
    details: "<",
    options: "<",
    onChange: "&",
    placeholder: "@",
    selectedTags: "<",
  },
  templateUrl,

  controller: class TagComponent {
    $onInit() {
      this.showList = false;
      this.selectedTagArr = this.selectedTags || [];
      this.listOptions = this.options;
      this.selectedOptionId = null;
      if (this.selectedTagArr && this.selectedTagArr.length > 0) {
        this.listOptions = this.listOptions.filter(
          (option) =>
            !find(this.selectedTagArr, (value) => value.id === option.id)
        );
      }
    }
    onInputClick() {
      this.showList = !this.showList;
    }
    onChangeOption() {
      if (this.selectedOptionId) {
        const optionDetails = find(
          this.listOptions,
          (option) => option.id === parseInt(this.selectedOptionId)
        );
        this.selectedTagArr.push(optionDetails);
        this.listOptions = this.listOptions.filter(
          (option) => option.id !== parseInt(this.selectedOptionId)
        );
        this.onChange({ details: this.selectedTagArr });
      }
    }
    removeAddedValues(data) {
      this.selectedTagArr = this.filterList(this.selectedTagArr, data);
      this.listOptions.push(data);
      this.onChange({ details: this.selectedTagArr });
    }

    filterList(list, data) {
      return list.filter(({ id }) => parseInt(id) !== parseInt(data.id));
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/tags/tags.component.js